import z from 'zod';
import { scopedEntity, assetRef, string } from '../common';
export const assetGroup = z.object({
    ...scopedEntity.shape,
    name: string,
    description: string.nullish(),
    assets: assetRef.array(),
});
